import { Common } from './common';
import {
  CreateUpdateValues,
  TemplateFieldCompiled,
  TemplateIdentifier,
  DetailsResponse,
} from './models/noteTemplate';
import { NoteFieldWithConfig } from './models/note/field';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(
    providerUserId?: string,
    limit?: number,
  ): Promise<TemplateIdentifier[]> {
    const url = this.common.constructPath(`/note-templates/`, {
      providerUserId,
      limit,
    });
    const { results } = await this.common.getJSON(url);
    return results.templates;
  }

  async getDetails(noteTemplateId: string): Promise<DetailsResponse> {
    const url = this.common.constructPath(`/note-templates/${noteTemplateId}`);
    const { results } = await this.common.getJSON(url);
    return results;
  }

  async createTemplate(data: CreateUpdateValues): Promise<DetailsResponse> {
    const url = this.common.constructPath(`/note-templates/`);
    const { results } = await this.common.postJSON(url, data);
    return results;
  }
  async updateTemplate(
    noteTemplateId: string,
    data: CreateUpdateValues,
  ): Promise<DetailsResponse> {
    const url = this.common.constructPath(`/note-templates/${noteTemplateId}`);
    const { results } = await this.common.putJSON(url, data);
    return results;
  }

  async deleteTemplate(noteTemplateId: string): Promise<void> {
    const url = this.common.constructPath(`/note-templates/${noteTemplateId}`);
    await this.common.deleteJSON(url);
    return;
  }

  async compile(args: {
    noteId: string;
    noteTemplateId: string;
  }): Promise<TemplateFieldCompiled[]> {
    const { noteId, noteTemplateId } = args;
    const url = this.common.constructPath(
      `/note-templates/${noteTemplateId}/compile`,
    );
    return this.common.postJSON(url, { noteId });
  }

  async previsitApplyTemplate(
    previsitFormSetId: string,
  ): Promise<NoteFieldWithConfig[]> {
    const url = this.common.constructPath(`/note-templates/previsit/apply`);
    return this.common.postJSON(url, { previsitFormSetId });
  }
}
